/**
 * Created by hp on 2017/6/26.
 */
import ChannelDescription from './ChannelDescription';
import ChannelLectureList from './ChannelLectureList';
import ChannelLectureRecord from './ChannelLectureRecord';
import ChannelBottomNav from './ChannelBottomNav';
import ChannelPayPanel from './ChannelPayPanel';
import ChannelDialog from './ChannelDialog';
import ChannelLiveroomBar from './ChannelLiveroomBar';
import ChannelShareCard from './ChannelShareCard';
import ChannelMonthGiftDialog from './ChannelMonthGiftDialog';
import ChannelPopular from './ChannelPopular'
import ChannelLimitPrice from './ChannelLimitPrice'
import ChannelGroupBuyList from './ChannelGroupBuyList'
import ChannelGroupBuyListModal from './ChannelGroupBuyListModal'

export {
    ChannelDescription,
    ChannelLectureList,
    ChannelLectureRecord,
    ChannelBottomNav,
    ChannelPayPanel,
    ChannelDialog,
    ChannelLiveroomBar,
    ChannelShareCard,
    ChannelMonthGiftDialog,
    ChannelPopular,
    ChannelLimitPrice,
    ChannelGroupBuyList,
    ChannelGroupBuyListModal,
}


// WEBPACK FOOTER //
// ./src/components/channel/index.js